import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { IAdvAccountInfo } from '@typings/rootSlice';

export const advApi = createApi({
    reducerPath: 'advApi',
    baseQuery: fetchBaseQuery({ baseUrl: `${__GATEWAY_URL__}/go-api` }),
    endpoints: (builder) => ({
        getAdvAccountInfo: builder.query<IAdvAccountInfo, string>({
            query: (id) => ({ url: `/v1.0/advAccounts/info/${id}` }),
        }),
    }),
});

export const {
    useGetAdvAccountInfoQuery,
} = advApi;